import { Box, Button, Paper, Typography } from "@mui/material";
import React from "react";
import DataTable from "./DataTable";
import DataContext from "./context";
import { useDataManager } from "./useData";
import { useNavigate } from "react-router-dom";

const Users = () => {
  const navigate = useNavigate();
  return (
    <Paper sx={{ p: 2 }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h5">Usuários</Typography>

        <Button onClick={() => navigate("./create")} variant="contained">
          Registrar
        </Button>
      </Box>
      <DataTable />
    </Paper>
  );
};

const Index = () => {
  return (
    <DataContext.Provider value={useDataManager()}>
      <Users />
    </DataContext.Provider>
  );
};

export default React.memo(Index);
